module.exports = __webpack_public_path__ + "img/green-check-bold-icon.2274ea40.svg";